export default function (value) { 
    if (!value)
        return false;
    if (value == null)
        return false;
    
    if (value.constructor === Object) {
        value = value.value;
    }
    
    let parsedValue = JSON.parse(value);
    if (!parsedValue.value)
        return false;
    if (!parsedValue.unitSelected)
        return false;
    
    return true;
}